import React, { useCallback, useContext, useEffect, useState } from 'react'
import { WordsStyles } from './Style'
import { LightButton, SpaceBetween } from 'styles/GlobalStyle'
import { SvgIcon } from '@mui/material'
import { ReactComponent as LinesIcon } from 'assets/icons/Lines.svg';
import { ReactComponent as AddIcon } from 'assets/icons/Add.svg';
import { useSelector } from 'react-redux';
import { CreateAssessmentDefContext } from './CreateAssessmentDefContext';
import { useDispatch } from 'react-redux';
import { arrayPush, change } from 'redux-form';
import { AutoComplete, RenderFields } from 'components/Form';
import { grades, visibleTypes } from 'keys';
import { map } from 'lodash';
import { getWordDefsFetch } from 'store/middlewares/words.crud';
import { queryClient as qc } from 'keys';
import { useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import DraftText from './DraftText';

const Words = () => {
    const { grade, setGrade, categoryItem, currentItemIndex, setCurrentItemIndex } = useContext(CreateAssessmentDefContext)
    const { itemsKey } = categoryItem || {}
    const formValues = useSelector(state => state.form.createAssessmentDef?.values)
    const words = formValues?.[itemsKey] || []
    const dispatch = useDispatch()
    const params = useParams()
    const { assessmentDefID } = params

    const [wordIndex, setWordIndex] = useState(0)
    const [currentPage, setCurrentPage] = useState(0)

    const _ = useQuery({
        queryFn: [qc.wordDefs, assessmentDefID],
        queryFn: async ({ signal }) => {
            try {
                const { data } = await getWordDefsFetch({ signal, id: assessmentDefID });
                let words = map(data.word_defs, 'word_def_text');
                if (words.length % 9) {
                    words = [...words, ...new Array(9 - (words.length % 9)).fill("")];
                }
                dispatch(change('createAssessmentDef', `words`, words))
                return words

            } catch (error) {
            }
            return [];
        },
        refetchOnWindowFocus: false,
        enabled: !!assessmentDefID
    })

    const gradesArray = map(grades, (obj, id) => ({
        id: obj.fontsize[visibleTypes.WORD_GROUP],
        ...obj
    }))

    const { id: fontSize, rowCount, cardWidth, columnCount, columnGap } = grade || {}
    const cardCount = (columnCount * rowCount) || 9

    const addNewPage = useCallback(() => {
        setCurrentItemIndex(currentItemIndex => currentItemIndex + 1)
        setWordIndex(currentItemIndex => currentItemIndex + cardCount)
        let words = formValues?.words || []
        words = [...words, ...new Array(cardCount).fill("")];
        dispatch(change('createAssessmentDef', "words", words))
        setCurrentPage(currentPage => currentPage + 1)
    }, [formValues])

    const goToPage = (index) => {
        setCurrentPage(index)
        setWordIndex(index * cardCount)
    }

    const updateGrade = useCallback((value) => {
        const { rowCount, columnCount } = value
        const numWords = rowCount * columnCount
        if (words.length % numWords) {
            let nWords = [...words]
            nWords.push(...new Array(numWords - (nWords.length % numWords)).fill(""));
            dispatch(change('createAssessmentDef', 'words', nWords))
        }
        setGrade(value)
    }, [words])

    useEffect(() => {
        dispatch(change('createAssessmentDef', itemsKey, new Array(9).fill("")))
    }, [])

    useEffect(() => {
        setTimeout(() => {
            console.log("מילים", words);
        }, 3000);
    }, [words])

    return (
        <WordsStyles
            cardWidth={cardWidth}
            columnCount={columnCount}
            columnGap={columnGap}
            fontSize={fontSize}>
            <div className='wrap-pages'>
                <div className='pages'>
                    {[...new Array(Math.ceil(words.length / 9))]?.map((page, index) => {
                        return (
                            <div
                                className={`page ${currentPage == index ? "selected-page" : ""}`}
                                key={page?.id}
                                onClick={() => goToPage(index)}
                            >
                                {/* {words[index + 1] &&
                                    <div className='placeholder-lines'>
                                        <div className='placeholder-lines-icon'>
                                            <SvgIcon fontSize='small' component={LinesIcon} inheritViewBox />
                                        </div>
                                    </div>} */}
                                <div className='num-page'>
                                    {`${index + 1}`}
                                </div>
                            </div>
                        )
                    })}
                    <div>
                        <SpaceBetween />
                        <LightButton
                            variant="solid"
                            size="small"
                            label='הוספת עמוד'
                            action={addNewPage}
                            icon={<SvgIcon fontSize='small' component={AddIcon} inheritViewBox />}
                        />
                    </div>
                </div>
                <div className='select-font-size'>
                    <AutoComplete
                        placeholder={"בחר שכבה כדי לראות את גודל הפונט"}
                        options={gradesArray}
                        input={{
                            value: grade,
                            onChange: updateGrade
                        }}
                    />
                </div>
            </div>
            <div className='wrap-content'>
                <div className='content'>
                    <div className='words'>
                        {words?.map((word, index) =>
                            !(
                                index >= wordIndex &&
                                index <= wordIndex + (cardCount - 1)
                            ) ||
                            <div className='word'>
                                <RenderFields fields={[
                                    {
                                        name: `${itemsKey}[${index}]`,
                                        component: "inputBase",
                                        placeholder: categoryItem.cardLabel,
                                        className: `word-field`,
                                    }
                                ]} />
                            </div>
                        )}
                    </div>
                </div>
                <div className='content draft-box'>
                    <DraftText />
                </div>
            </div>

        </WordsStyles>
    )
}

export default Words